import ChatInput, { ChatInputProps } from './ChatInput';
import styles from './Chat.module.scss';

export interface ChatFloatingInputProps extends Omit<ChatInputProps, 'variant'> {}

const ChatFloatingInput = (props: ChatFloatingInputProps) => {
  return (
    <div className={styles.floatingInputContainer}>
      <div className={styles.floatingInputInner}>
        <ChatInput {...props} variant="floating" />
      </div>
    </div>
  );
};

export default ChatFloatingInput;
